import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import DefaultLayout from '../layouts/DefaultLayout';
import Home from './Home';
import SignUp from './SignUp';
import NotFound from './NotFound';

const ScreenRouter = () => (
  <Router>
    <DefaultLayout>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route exact path="/sign-up/:kind/:step?" component={SignUp} />
        <Route component={NotFound} />
      </Switch>
    </DefaultLayout>
  </Router>
);

export default ScreenRouter;